module.exports = __webpack_public_path__ + "static/img/yytx32.4133f5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx32.png
// module id = 899
// module chunks = 0